// extracted by mini-css-extract-plugin
export default {"container":"pills-menu_container__dHfw3","items":"pills-menu_items__1h8Ss","item":"pills-menu_item__mPQVK"};